module.exports = __webpack_public_path__ + "static/media/travel.368aff99.GIF";